module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_kitchenware_c05e2dedcc57e55cb7f573739e9d6b9a.png";